module.exports = __webpack_public_path__ + "static/media/insect(38).050eb587.PNG";